import MsBHUSingleSiteModal from './container'
export default MsBHUSingleSiteModal
